"use strict";

require("core-js/modules/es6.string.small");

var _taggedTemplateLiteral = require("/usr/local/src/bitcoincom-notary/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  \n    ", "\n\n    /* // NOTE: the order of these styles DO matter */\n    ", ";\n    ", "\n    ", "\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", "\n    ", ";\n    ", "\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-family: inherit;\n  font-size: inherit;\n  font-weight: inherit;\n  color: inherit;\n  background: none;\n  border: none;\n  outline: none;\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  & input {\n    font-family: \"Gilroy\", sans-serif;\n    font-size: 16px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importStar(require("styled-components"));

var presentDateRangePicker_1 = __importDefault(require("./presentDateRangePicker"));

var dayPicker_1 = __importDefault(require("./dayPicker"));

var dayPickerKeyboardShortcuts_1 = __importDefault(require("./dayPickerKeyboardShortcuts"));

var dayPickerNavigation_1 = __importDefault(require("./dayPickerNavigation"));

var dateInput_1 = __importDefault(require("./dateInput"));

var calendarDay_1 = __importDefault(require("./calendarDay"));

var calendarMonth_1 = __importDefault(require("./calendarMonth"));

var singleDatePicker_1 = __importDefault(require("./singleDatePicker"));

var rangeDatePicker_1 = __importDefault(require("./rangeDatePicker"));

var reset = styled_components_1.css(_templateObject());
var Wrapper = styled_components_1["default"].div(_templateObject2(), function (_ref) {
  var picker = _ref.picker,
      hideKeyboardShortcutsPanel = _ref.hideKeyboardShortcutsPanel,
      small = _ref.small,
      theme = _ref.theme,
      width = _ref.width;
  return styled_components_1.css(_templateObject3(), reset, presentDateRangePicker_1["default"]({
    theme: theme
  }), typeof picker === "undefined" && singleDatePicker_1["default"]({
    theme: theme,
    small: small
  }), picker === "single" && singleDatePicker_1["default"]({
    theme: theme,
    small: small
  }), !hideKeyboardShortcutsPanel && dayPickerKeyboardShortcuts_1["default"], calendarDay_1["default"]({
    theme: theme
  }), calendarMonth_1["default"]({
    theme: theme
  }), dayPickerNavigation_1["default"]({
    theme: theme
  }), dayPicker_1["default"]({
    theme: theme
  }), dateInput_1["default"]({
    theme: theme,
    width: width
  }), picker === "range" && rangeDatePicker_1["default"]({
    theme: theme,
    small: small
  }));
});
exports["default"] = Wrapper;